import { SmsTemplateActionMenu } from "./SmsTemplateActionMenu"
import { Typography } from "@mui/material";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";

export const SMS_PROVIDERS = {
  YOUR_BULK_SMS: "yourbulksms",
  ESENDEX: "esendex",
}

export const thirdPartyConfigTabs = [
  // { value: "payment config", label: "PAYMENT CONFIG" },
  // { value: "mail config", label: "MAIL CONFIG" },
  { value: "sms config", label: "SMS CONFIG" },
  { value: "sms templates", label: "SMS TEMPLATES" },
  // { value: "Recaptcha", label: "RECAPTCHA" },
  // { value: "google map apis", label: "GOOGLE MAP APIs" },
]

export const yourbulksmsInitialValues = {
  provider_name: "yourbulksms",
  config: {
    authkey: "",
    sender: "",
    route: "",
    country: "91",
    base_url: "http://control.yourbulksms.com/api/sendhttp.php",
  },
  is_active: true,
}

export const smsTemplatesInitialValues = {
  template_name: "",
  dlt_template_id: "",
  template_body: "",
  is_active: true,
}

export const esendexInitialValues = {
  provider_name: "esendex",
  config: {
    username: "",
    password: "",
    accountreference: "",
    base_url: "https://api.esendex.com/v1.0",
  },
  is_active: true,
}

export const smsTemplatesColumns = (onEdit, isReadOnly = false) =>[
  { 
    field: "template_name", 
    headerName: "Template Name", 
    flex: 1,
    renderCell: (params) => (
      <Typography
        variant="body2"
        sx={{ cursor: isReadOnly ? "default" : "pointer", color: isReadOnly ? "text.primary" : "primary.main" }}
        onClick={() => {
          if (!isReadOnly) {
            onEdit(params.row);
          }
        }}
      >
        {params.value}
      </Typography>
    ), 
  },
  { 
    field: "dlt_template_id", 
    headerName: "DLT Template ID", 
    flex: 1 
  },
  { 
    field: "template_body", 
    headerName: "Template Body", 
    flex: 2 
  },
  {
    field: "created_at",
    headerName: "Created At",
    flex: 1,
    type: "date",
    renderCell: ({ value }) => (
        <span>{yearFirstDateTimeFormat(value)}</span>
    )
  },
  {
    field: "is_active",
    headerName: "Active",
    flex: 1,
    renderCell: ({ value }) => (value ? "Yes" : "No"),
  },
  {
    field: "Actions",
    width: 70,
    sortable: false,
    renderCell: (params) => (
      !isReadOnly ? (
        <SmsTemplateActionMenu id={params.row.sms_template_pk} onEdit={() => onEdit(params.row)} />
      ) : null
    )
  },
]